/** Google Ads brand mark — rendered from the official logo asset so it stays
 *  pixel-accurate to the brand instead of an approximated hand-built vector. */
export function GoogleAdsLogo({ className }: { className?: string }) {
  return (
    <img src="/assets/images/google-ads-logo.png" alt="" aria-hidden="true" className={className} />
  );
}
